export default "__VITE_ASSET__76b623ee__"